<script setup lang="ts">
import { inject } from 'vue'

interface Props {
  side?: 'top' | 'bottom'
}

const props = withDefaults(defineProps<Props>(), {
  side: 'bottom'
})

const { isOpen } = inject('select', {
  isOpen: { value: false }
})
</script>

<template>
  <div
    v-if="isOpen"
    :class="[
      'absolute z-50 max-h-60 w-full overflow-auto rounded-md border bg-popover text-popover-foreground shadow-md',
      props.side === 'top' ? 'bottom-full mb-1' : 'mt-1'
    ]"
  >
    <div class="p-1">
      <slot />
    </div>
  </div>
</template> 